var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"home"}},[(_vm.dataFetched)?[(_vm.profileBanners.length)?_c('banner-container',{attrs:{"banners":_vm.profileBanners}}):_vm._e(),_c('router-view',{class:_vm.showLoginAsBanner && 'banner-present'})]:(!_vm.dataFetched && _vm.cssLoaded)?_c('loading-spinner',{staticClass:"loading-wrapper"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }